module.exports = __webpack_public_path__ + "static/img/menu3-img4.0876677e.png";